import { blockedTimer } from './helpers';
import { fetchData, postData } from './fetch.js';

window.addEventListener('load', () => {
  const authForm = document.querySelector('.auth-form');
  const ttlValue = document.querySelector('.auth-wrapper .resend-code span');
  const codeInput = document.querySelector('.login-page .code-input input');
  const loginTextErrorWrapper = document.querySelector(
    '.login-text-error-wrapper',
  );
  const blockedErrorTimer = document.querySelector('.blocked-error-timer span');
  const loginTextWrapper = document.querySelector('.login-text-wrapper');
  const blockedErrorText = document.querySelector('.blocked-error-text');
  const mfaInputs = document.querySelectorAll('.login-form .code-select-radio-button');
  const mfaInput = document.getElementById('code-mfa');

  let phonesValues = {
    phones: [],
    expires: null,
  };

  const phoneValuesFromLS = localStorage ? localStorage.getItem('phonesValues') : null;

  if (phoneValuesFromLS) {
    phonesValues = JSON.parse(phoneValuesFromLS);

    if (phonesValues.expires <= Date.now()) {
      localStorage.removeItem('phonesValues');
    }
  }

  let interval;
  let mfaInterval;
  let blockedInterval;
  let phoneBlockedInterval;

  const getMfaToken = () => { 
    if (authForm) { 
      authForm.submit();
    }
  }

  const getMfaStatus = async (token) => { 
    const response = await fetchData(`/login/mfa/${token}`);

    if (response.data.status === 'FAILED') {
      clearInterval(mfaInterval);
      clearInterval(interval);
      
      window.location.href = '/login';
    } else if (response.data.status === 'VERIFIED') {
      clearInterval(mfaInterval);
      clearInterval(interval);

      getMfaToken()
    }
  }

  if (mfaInputs) {
    [].forEach.call(mfaInputs, (input) => {
      const { value } = input;

      input.addEventListener('change', () => {
        if (mfaInput) { 
          mfaInput.setAttribute('value', value);
        }
      });

    });
  }


  if (authForm) {
    authForm.addEventListener('submit', async (e) => {
      if (window.location.href.includes('SMS')) {
        e.preventDefault();

        const code = document.getElementById('code').value;

        const body = {
          code,
        };

        const response = await postData('/login/mfa/code', body);

        if (response) {
          if (response.statusCode === 400) {
            codeInputContainer.classList.add('error');

            if (response.errors && response.errors.code && codeErrorsList) {
              setErrors(codeErrorsList, response.errors.code);
            }

            if (response.errors && response.errors._global && errorMessage) {
              errorMessage.classList.add('visible');
              setErrors(errorMessage, response.errors._global);
            }
          } else {
            codeInputContainer.classList.remove('error');
            codeInputContainer.classList.add('valid');

            if (codeErrorsList) {
              codeErrorsList.innerHTML = '';
            }

            if (errorMessage) {
              errorMessage.textContent = '';
              errorMessage.classList.remove('visible');
            }

            getMfaToken(response.data.token)
          }
        }

      } else { 
        const submitButton = authForm.querySelector('.next-button');
        const phone = document.getElementById('phone-input').value;
  
        if (
          phonesValues.phones.length < 3 &&
          !phonesValues.phones.find((item) => item === phone)
        ) {
          phonesValues.phones.push(phone);
          phonesValues.expires = Date.now() + 60 * 60 * 1000;

          if (localStorage) {
            localStorage.setItem('phonesValues', JSON.stringify(phonesValues));
          }
        }
  
        if (phonesValues.phones.length === 3) {
          phonesValues.expires = Date.now() + 120 * 1000;

          if (localStorage) {
            localStorage.setItem('phonesValues', JSON.stringify(phonesValues));
          }
        }
  
        if (submitButton) {
          submitButton.textContent = 'Загрузка...';
          submitButton.setAttribute('disabled', 'disabled');
        }
  
        if (codeInput && codeInput.value && localStorage) {
          localStorage.removeItem('phonesValues');
        }
      }
    });
  }

  if (codeInput) {
    codeInput.addEventListener('keyup', (e) => {
      codeInput.value = e.target.value.replace(/[^0-9]/g, '');
    });
  }

  if (ttlValue && ttlValue.innerHTML.length) {
    let ttl = parseInt(ttlValue.innerHTML, 10);
    let mfaTtl = parseInt(ttlValue.innerHTML, 10);
    const mfaToken = ttlValue.getAttribute('data-mfa');

    const minutes = Math.floor(ttl / 60);
    const seconds = ttl - minutes * 60;

    ttlValue.textContent = `${minutes > 9 ? '' : '0'}${minutes}:${seconds > 9 ? '' : '0'}${seconds}`;

    interval = setInterval(() => {
      if (ttl > 0) {
        ttl--;

        const minutes = Math.floor(ttl / 60);
        const seconds = ttl - minutes * 60;

        ttlValue.textContent = `${minutes > 9 ? '' : '0'}${minutes}:${seconds > 9 ? '' : '0'}${seconds}`;
      }
    }, 1000);

    if (ttl === 0) {
      clearInterval(interval);

      window.location.href = '/login';
    }

    mfaInterval = setInterval(() => {
      if (mfaTtl > 0) {
        mfaTtl -= 5;

        getMfaStatus(mfaToken);
      }
    }, 5000);

    if (mfaTtl === 0) {
      clearInterval(mfaInterval);
    }
  }

  if (ttlValue) {
    const expires = parseInt(ttlValue.getAttribute('data-expires'), 10);

    
    if (expires) { 
      timeout = setTimeout(() => {
        window.location.href = '/login';
      }, expires - new Date().getTime());
    }

  }

  if (window.location.href.includes('/login')) {
    if (
      phonesValues &&
      phonesValues.phones &&
      phonesValues.phones.length === 3
    ) {
      let time = Math.round(
        (parseFloat(phonesValues.expires) - Date.now()) / 1000,
      );

      const text =
        'Повторная отправка SMS с кодом с вашего бразуера возможна через';

      if (loginTextWrapper) {
        loginTextWrapper.classList.add('hidden');
      }

      if (loginTextErrorWrapper) {
        loginTextErrorWrapper.classList.add('visible');
      }

      if (blockedErrorText) {
        blockedErrorText.textContent = text;
      }

      phoneBlockedInterval = setInterval(() => {
        time = time - 1;

        const timeString = blockedTimer(time);

        if (blockedErrorTimer) {
          blockedErrorTimer.textContent = timeString;
        }

        if (time === 0) {
          clearInterval(phoneBlockedInterval);

          window.location.reload();
        }
      }, 1000);
    }
  }

  if (loginTextErrorWrapper && loginTextErrorWrapper.dataset.time) {
    let time = parseInt(loginTextErrorWrapper.dataset.time);

    blockedInterval = setInterval(() => {
      time = time - 1;
      const timeString = blockedTimer(time);

      if (blockedErrorTimer) {
        blockedErrorTimer.textContent = timeString;
      }

      if (time === 0) {
        clearInterval(blockedInterval);

        window.location.reload();
      }
    }, 1000);
  }
});
